import api from "../../../services/apiClient"
import type { RoleFormValues } from "../models/role"

const BASE = "admin-roles"
const PERM_BASE = "admin-permissions"

export const roleApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },
  getByName: async (name: string) => {
    const { data } = await api.get(`${BASE}/${encodeURIComponent(name)}`)
    return data?.data ?? data
  },
  create: async (values: RoleFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  update: async (name: string, values: Partial<RoleFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${encodeURIComponent(name)}`, values)
    return data?.data ?? data
  },
  delete: async (name: string) => {
    const { data } = await api.delete(`${BASE}/delete/${encodeURIComponent(name)}`)
    return data
  },
  getPermissions: async (name: string) => {
    const { data } = await api.get(`${BASE}/${encodeURIComponent(name)}/permissions`)
    return data?.data ?? data
  },
  assignPermissions: async (name: string, payload: { add: string[]; remove: string[] }) => {
    const { data } = await api.post(`${BASE}/${encodeURIComponent(name)}/assign-permissions`, payload)
    return data?.data ?? data
  },
  getUsers: async (name: string, params?: Record<string, unknown>) => {
    const { data } = await api.get(`${BASE}/${encodeURIComponent(name)}/users`, { params })
    return data?.data ?? data
  },
  assignUsers: async (name: string, payload: { add: number[]; remove: number[] }) => {
    const { data } = await api.post(`${BASE}/${encodeURIComponent(name)}/assign-users`, payload)
    return data?.data ?? data
  },
  getAllPermissions: async () => {
    const { data } = await api.get(PERM_BASE)
    return data?.data ?? data
  },
}
